module.exports = __webpack_public_path__ + "img/cabins--mobile.4fc35d32.jpg";